// @ vendors
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');
const { MGM } = require('constants/flagBasedFeatures');

//@utilities
const { countActiveFilters, findActiveFilters } = require('utilities/filtersHelper');
const uniq = require('lodash/array/uniq');

const getGuardianInvitationInfoError = (error) => ({
    type: actionTypes.REFERRALS_SET_GUARDIAN_INVITATION_ERROR,
    payload: {
        error
    }
});

const getGuardianInvitationInfoRequest = () => ({
    type: actionTypes.REFERRALS_SET_GUARDIAN_INVITATION_REQUEST
});

const getGuardianInvitationInfoSuccess = (response) => ({
    type: actionTypes.REFERRALS_SET_GUARDIAN_INVITATION_SUCCESS,
    payload: {
        invitationDetailList: response.inviationDetailList,
        totalAccumulateMgmTotal: response.totalAccumulateMgmTotal
    }
});

const referralsGetPromotionListIsFetching = () => ({
    type: actionTypes.REFERRALS_GET_PROMOTION_DETAILS_IS_FETCHING,
})

const referralsGetPromotionListSuccess = (response) => ({
    type: actionTypes.REFERRALS_GET_PROMOTION_DETAILS_SUCCESS,
    payload: {
        promotionsList: response.promotionList
    }
});

const referralsGetPromotionListError = (error) => ({
    type: actionTypes.REFERRALS_GET_PROMOTION_DETAILS_ERROR,
    payload: {
        error
    }
});

const getGuardianInvitationInfo = () => (dispatch, getState) => {
    const immReferrals = getState().referrals;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const promotionCodes = uniq(immReferrals.get('allPromotions').map(immPromotion => immPromotion.get('promotionCode')).toJS());
    const immFilters = immReferrals.get('filters');
    const immDateFilter = immReferrals.getIn(['filters', 'date']);
    const immStateFilter = immReferrals.getIn(['filters', 'state']);
    const immGiftFilter = immReferrals.getIn(['filters', 'gift']);

    const requestData = {
        header: {
            version: 2
        },
        query: {
            promotionCodes
        }
    }

    if(immFlagBasedFeatures.get('web-MGM-passport-enabled') && immFlagBasedFeatures.get(MGM)) {
        requestData.header.version = 3;
    }

    if (findActiveFilters(immFilters)) {

        requestData.query.filterBy = {};

        if(immDateFilter.get('isActive')) {
            const dateFrom = immDateFilter.get('from');
            const dateTo = immDateFilter.get('to');
            if(!!dateFrom || !!dateTo) {
                requestData.query.filterBy.invitationDate = {};
                if(!!dateFrom) {
                    requestData.query.filterBy.invitationDate.fromDate = dateFrom.format(DATE_FORMAT_API);
                }
                if(!!dateTo) {
                    requestData.query.filterBy.invitationDate.toDate = dateTo.format(DATE_FORMAT_API);
                }
            }
        }

        if(immStateFilter.get('isActive')) {
            requestData.query.filterBy.status = immStateFilter.get('selected');
        }

        if(immGiftFilter.get('isActive')) {
            requestData.query.filterBy.giftType = immGiftFilter.get('selected');
        }
    }

    dispatch(getGuardianInvitationInfoRequest());
    return APIPost({
        dispatch,
        endpoint: 'referralsGuardianInvitation',
        params: requestData
    })
        .then(response => {
            dispatch(getGuardianInvitationInfoSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getGuardianInvitationInfoError(response.error));
            } else {
                throw response;
            }
        });
}

const referralsGetPromotionsList = () => (dispatch, getState) => {
    const prefix = getState().globalVariables.getIn(['variables', 'parameters', 'member_get_member_multi_promo', 'prefix']) || '';
    const immFlagBasedFeatures = getState().flagBasedFeatures;


    if (!!prefix) {
        const requestData = {
            header: {
                version: 2
            },
            query: {
                prefix
            }
        };

        if(immFlagBasedFeatures.get('web-MGM-passport-enabled') && immFlagBasedFeatures.get(MGM)) {
            requestData.header.version = 3;
        }

        dispatch(referralsGetPromotionListIsFetching());
        return APIGet({
            dispatch,
            endpoint: 'referralsGetPromotionsList',
            params: requestData
        })
        .then(response => {
            dispatch(referralsGetPromotionListSuccess(response));
            dispatch(getGuardianInvitationInfo()); // call invitations to show total amount earned in header
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(referralsGetPromotionListError(response.error.description));
            } else {
                throw response;
            }
        });
    }
};

const setReferralsInvitationsFilters = filters => dispatch => {
    dispatch({
        type: actionTypes.REFERRALS_INVITATIONS_SET_FILTERS, // tagged for analytics
        payload: {
            filters
        }
    });
};

const clearReferralsInvitationsFilters = () => (dispatch) => {
    dispatch({
        type: actionTypes.REFERRALS_INVITATIONS_CLEAR_FILTERS // tagged for analytics
    });
}

const resetReferralsInvitationsFilter = (filter) => (dispatch, getState) => {
    const immFilters = getState().referrals.get('filters');

    if (countActiveFilters(immFilters) === 1) {
        dispatch(clearReferralsInvitationsFilters());
    } else {
        dispatch({
            type: actionTypes.REFERRALS_INVITATIONS_RESET_FILTER,
            payload: {
                filterKey: filter
            }
        });
    }
}
module.exports = {
    clearReferralsInvitationsFilters,
    getGuardianInvitationInfo,
    referralsGetPromotionsList,
    resetReferralsInvitationsFilter,
    setReferralsInvitationsFilters
};
